import i18n from '../../i18n'
import VueI18n from 'vue-i18n'

const url = {
  computed: {
    url(): (v: string) => true | VueI18n.TranslateResult {
      return (v: string) => {
        if (!v) return true
        try {
          new URL(v)
          return true
        } catch {
          return i18n.t('validation.url')
        }
      }
    },
  },
}

export default url
